import type { IApplicationState } from 'shared/types/redux';

export const selectCPDDraftId = (state: IApplicationState) => state.cpd.cpdDraftId;
